/* @flow */

import Promise from 'bluebird';

import bugsnagClient from '../clients/bugsnag-client';
import { requestStarted, requestEnded } from '../modules/network/actions';


function decorate(httpClient: any, store: Object) {
  httpClient.interceptors.request.use(
    (config) => {
      const { url, method } = config;
      bugsnagClient.leaveBreadcrumb(`HTTP ${config.method.toUpperCase()} started..`, {
        type: 'request',
        url,
        method,
      });

      return requestStarted(config)(store.dispatch);
    }, (error) => {
      requestStarted(error)(store.dispatch);

      bugsnagClient.notify(error);

      return Promise.reject(error);
    },
  );

  httpClient.interceptors.response.use((response) => {
    const { config, status } = response,
          { url, method } = config;

    bugsnagClient.leaveBreadcrumb(`HTTP ${method.toUpperCase()} (${status}) ended..`, {
      type: 'request',
      url,
      method,
      status,
    });

    return requestEnded(response)(store.dispatch);
  }, (error) => {
    requestEnded(error)(store.dispatch);

    bugsnagClient.notify(error, (report) => {
      const { response } = error;

      if (response) {
        report.metadata = { response: JSON.parse(JSON.stringify(response)) }; //eslint-disable-line
      }
    });

    return Promise.reject(error);
  });
}

export default decorate;
